module.exports = __webpack_public_path__ + "img/mta-qld.f1cb1b3a.webp";